import {updateObject} from "../../shared/utils/updateObject";
import * as actionTypes from "../actionTypes";
import {
    addRechargePropertiesInitialState,
    changeApnInitialState,
    changeIpInitialState,
    eSimDetailsInitialState,
    initialActiveServiceRequestState,
    initialAllSelectedAttive,
    initialCollaboratorsState,
    initialCsvDownloadLoadingState,
    initialDetailsState,
    initialEdhDetailsState,
    initialESimDistribuzione,
    initialExtrasDetailsState,
    initialFilterDataState,
    initialFilterState,
    initialGroupCountState,
    initialOcsDetailsState,
    initialResetPasswordState,
    initialSospeseAndSostitutiveState,
    simSelectedRowInitialState,
    simsToBeRechargedInitialState,
    simSuggestionInitialState,
    simTabInitialState
} from "./helper";


const initialState = {
    selectedTab: 0,
    attive: simTabInitialState,
    daAttivare: simTabInitialState,
    inAttivazione: simTabInitialState,
    sospese: initialSospeseAndSostitutiveState,
    sostitutive: initialSospeseAndSostitutiveState,
    details: initialDetailsState,
    filter: initialFilterState,
    filterData: initialFilterDataState,
    filterClicked: false,
    simSelectedRow: simSelectedRowInitialState,
    dashboard: true,
    numbersBlockedList: [],
    simSuggestion: simSuggestionInitialState,
    activeServiceRequest: initialActiveServiceRequestState,
    changeIpAddress: changeIpInitialState,
    changeApn: changeApnInitialState,
    collaborators: initialCollaboratorsState,
    edhDetails: initialEdhDetailsState,
    ocsDetails: initialOcsDetailsState,
    extrasDetails: initialExtrasDetailsState,
    groupCount: initialGroupCountState,
    resetPassword: initialResetPasswordState,
    csvDownloadLoading: initialCsvDownloadLoadingState,
    simsToBeRecharged: simsToBeRechargedInitialState,
    addRechargeProperties: addRechargePropertiesInitialState,
    eSimDetails: eSimDetailsInitialState,
    eSimDistribuzione: initialESimDistribuzione,
    allSelectedAttive: initialAllSelectedAttive,
};

const fetchDataSuccessSim = (state, action) => {
    const tmpObject = {
        ...state[`${action.tab}`],
        data: action.data,
        count: action.count,
        rowsPerPage: action.rowsPerPage,
        page: action.page,
    };
    return updateObject(state, {[`${action.tab}`]: tmpObject});
};


const setSortingSim = (state, action) => {
    const tmpSort = {...state[`${action.tab}`], sorting: action.value};
    return updateObject(state, {[`${action.tab}`]: tmpSort});
};

const setSimSelectedTab = (state, action) => {
    return updateObject(state, {selectedTab: action.selectedTab});
};
const setSimSelectedRow = (state, action) => {
    return updateObject(state, {simSelectedRow: action.selectedRow});
};
const setDashboardValue = (state, action) => {
    return updateObject(state, {dashboard: action.value, selectedTab: action.tabIndex});
};

const changeFilterSim = (state, action) => {
    let tmpFilter;
    let updatedFilter;
    if (action.date === "") {
        tmpFilter = {...state.filter[`${action.name}`], value: action.value, text: action.text};
    } else {
        tmpFilter = {...state.filter[`${action.name}`], [`${action.date}`]: action.value};
    }
    updatedFilter = {...state.filter, [`${action.name}`]: action.date === "r" ? action.value : tmpFilter};
    return updateObject(state, {filter: updatedFilter});
};

const resetFilter = (state, action) => {
    return updateObject(state, {filter: action.value});
};
const setFilterClicked = (state, action) => {
    return updateObject(state, {filterClicked: action.val});
};

const setLoadingSim = (state, action) => {
    let tmpObj = {...state[`${action.tab}`], loading: action.value};
    if (action.value) {
        tmpObj = {...tmpObj, count: 0};
    }
    return updateObject(state, {[`${action.tab}`]: tmpObj});
};

const fetchSimStart = (state, action) => {
    let tmpObj = {...state[`${action.tab}`], loading: true, error: false};
    return updateObject(state, {[`${action.tab}`]: tmpObj});
}
const fetchSimError = (state, action) => {
    let tmpObj = {...state[action.tab], error: action.value};
    return updateObject(state, {[action.tab]: tmpObj});
}

const setWrenchLoadingSim = (state, action) => {
    let tmpObj = {...state.attive, wrenchLoading: action.value};
    if (action.value) {
        tmpObj = {...tmpObj, wrenchLoaded: false};
    }
    return updateObject(state, {attive: tmpObj});
};

const setWrenchDetailsAttive = (state, action) => {
    let sims = [...state.attive.data];
    let tmpSims = [];
    sims.forEach(s => {
        let tmpWrenchDetails = action.wrenchDetails.find(d => d.objectId === s.seriale);
        // delete tmpWrenchDetails.iccId;
        let tmpS = {...s, ...tmpWrenchDetails};
        tmpSims.push(tmpS);
    });
    let tmpObj = {
        ...state.attive,
        data: tmpSims,
        wrenchLoaded: true
    };
    return updateObject(state, {attive: tmpObj});
}

const changeAutocompleteListForSim = (state, action) => {
    return updateObject(state, {
        extrasDetails: updateObject(state.extrasDetails, {[`${action.forType}`]: action.autocompleteList})
    });
}

const createNewTag = (state, action) => {
    return updateObject(state, {
        extrasDetails: updateObject(state.extrasDetails, {
            tagsForSim: [...state.extrasDetails.tagsForSim, action.tag],
        })
    })
}

const deleteTag = (state, action) => {
    const attiveWithUpdatedTags = state.attive.data.filter(sim => {
        sim.tags.tags = sim.tags.tags.filter(tag => tag.label !== action.tagLabel)
        return sim;
    })
    return updateObject(state, {attive: {...state.attive, data: attiveWithUpdatedTags}})
}

const editTag = (state, action) => {
    const attiveWithUpdatedTags = state.attive.data.map(sim => {
        sim.tags.tags = sim.tags.tags.map(tag => {
            if (tag.id === action.tagId) {
                tag.name = action.tagName;
                tag.color = action.tagColor;
            }
            return tag;
        })
        return sim;
    })
    return updateObject(state, {attive: {...state.attive, data: attiveWithUpdatedTags}})
}

const setFilterLoadingOrError = (state, action) => {
    return updateObject(state, {filterData: {...state.filterData, [`${action.label}`]: action.value}});
}

const setFilterInputData = (state, action) => {
    return updateObject(state, {filterData: {...state.filterData, ...action.response}})
}

const updateCredit = (state, action) => {
    let creditoItemList = []
    if (state.simSelectedRow.creditoItemList) {
        creditoItemList = [...state.simSelectedRow.creditoItemList]
        creditoItemList.find(row => row.rowValue.includes("€")).rowValue = action.amount
    }
    return updateObject(state, {
        simSelectedRow: {
            ...state.simSelectedRow,
            ...(state.simSelectedRow.creditoItemList ? {creditoItemList: creditoItemList} : {})
        },
        ocsDetails: {
            ...state.ocsDetails,
            creditoOrCanoneValue: action.amount
        }
    })
}

const updateThreshold = (state, action) => {
    let tempList = [...state.simSelectedRow.creditoItemList];
    let tempList2 = tempList.filter(tlo => tlo.rowLabel !== "AutomaticaFAST")
    if(action.isAutomaticaFast) {
        let tempItem = tempList.filter(tlo => tlo.rowLabel === "AutomaticaFAST")
        const newCreditoItem = {
            ...tempItem[0],
            rowValue: action.changedItems.valore === 0 && action.changedItems.sogliaDiCreditoMin === -1 ? "Non Attiva" : "Attiva",
            cifraMaxRicaricabile: action.changedItems.cifraMaxRicaricabile,
            nmaxAutocharge: action.changedItems.nMaxAutoricariche,
            thresholdTextValoreRicarica: action.changedItems.valore,
            thresholdTextValoreSoglia: action.changedItems.sogliaDiCreditoMin
        }
        tempList2.push(newCreditoItem)
    } else {
        tempList2.push(action.creditoItem)
    }

    return updateObject(state, {simSelectedRow: {...state.simSelectedRow, creditoItemList: tempList2}})
}

const updateNumbersBlockedList = (state, action) => {
    return updateObject(state, {numbersBlockedList: action.numbersBlockedList})
}

const updateLoadingStatusForNumbersBlockedList = (state, action) => {
    return updateObject(state, {numbersBlockedListLoading: action.value})
}

const clearNumbersBlockedList = (state) => {
    return updateObject(state, {numbersBlockedList: []})
}

const setSimSuggestionLoading = (state, action) => {
    return updateObject(state, {simSuggestion: {...state.simSuggestion, loading: action.value}})
}

const setSimFilterSuggestionData = (state, action) => {
    return updateObject(state, {simSuggestion: {...state.simSuggestion, menuItems: action.suggestionList}});
}

const updateCheckedTagsSim = (state, action) => {
    const changedData = [...state[`${action.tab}`].data]
    changedData.find(s => s.seriale === action.seriale).tags.tags = action.updatedTags
    let tmpData = {...state[`${action.tab}`], data: changedData}
    return {...state, [`${action.tab}`]: tmpData}

}

const updateActiveServiceRequest = (state, action) => {
    return updateObject(state,
        {
            activeServiceRequest: updateObject(state.activeServiceRequest,
                {[`${action.typeOf}`]: action.value})
        })
}

const updateWrenchInAttivazione = (state, action) => {
    let tmp = state.inAttivazione.data
    action.wrenchDetails.forEach(wrench => {
        const indx = tmp.findIndex(sim => sim.seriale === wrench.objectId);
        tmp[indx].wrenchDto = wrench
    })
    return updateObject(state,
        {inAttivazione: {...state.inAttivazione, data: tmp}})
}

const updateTagFilterAutocomplete = (state, action) => {
    return updateObject(state, {filterData: updateObject(state.filterData, {tags: action.payload})})
}

const setBulkListAssociatedToSim = (state, action) => {
    return updateObject(state, {
        simSelectedRow: updateObject(state.simSelectedRow, {
            offerBulkList: updateObject(state.simSelectedRow.offerBulkList, {data: action.data})
        })
    })
}

const setLoadingBulkListAssociatedToSim = (state, action) => {
    return updateObject(state, {
        simSelectedRow: updateObject(state.simSelectedRow, {
            offerBulkList: updateObject(state.simSelectedRow.offerBulkList, {[`${action.name}`]: action.loading})
        })
    })
}

const updateChangeIpState = (state, action) => {
    return updateObject(state, {changeIpAddress: updateObject(state.changeIpAddress, {[action.name]: action.payload})})
}

const updateChangeApnState = (state, action) => {
    return updateObject(state, {changeApn: updateObject(state.changeApn, {[action.name]: action.payload})})
}

const updateChangeApnSelectValues = (state, action) => {
    return updateObject(state, {changeApn: updateObject(state.changeApn, {...action.payload})})
}

const setCollaborators = (state, action) => {
    return updateObject(state, {collaborators: updateObject(state.collaborators, {data: action.collaborators})})
}

const setLoadingCollaborators = (state, action) => {
    return updateObject(state, {collaborators: updateObject(state.collaborators, {loading: action.loading})})
}

const setErrorCollaborators = (state, action) => {
    return updateObject(state, {collaborators: updateObject(state.collaborators, {error: action.payload})})
}

const setSimDetailsLoadingOrError = (state, action) => {
    return updateObject(state, {
        [action.typeOf]: updateObject(state[action.typeOf],
            {
                [action.key]: action.value,
                ...(action.errorStatusCode && {
                    errorStatusCode: action.errorStatusCode,
                    errorMessage: action.errorMessage
                })
            })
    })
}

const setSimDetails = (state, action) => {
    return updateObject(state, {
        [action.typeOf]: updateObject(state[action.typeOf], {...action.payload}),
        ...(action.typeOf === 'edhDetails' && {simSelectedRow: updateObject(state.simSelectedRow, {...action.dto})})
    })
}

const setSimGroupCount = (state, action) => {
    return updateObject(state, {
        groupCount: updateObject(state.groupCount, {
            [action.key]: updateObject(state.groupCount[action.key], {count: action.payload})
        })
    })
}

const setSimGroupCountLoading = (state, action) => {
    return updateObject(state, {
        groupCount: updateObject(state.groupCount, {
            [action.key]: updateObject(state.groupCount[action.key], {loading: action.payload})
        })
    })
}

const setSimCsvDownloadLoading = (state, action) => {
    return updateObject(state, {
        csvDownloadLoading: updateObject(state.csvDownloadLoading, {
            [action.key]: action.payload
        })
    })
}

const setSimResetPasswordValues = (state, action) => {
    return updateObject(state, {resetPassword: updateObject(state.resetPassword, {[action.name]: action.payload})})
}

const setSimsToBeRecharged = (state, action) => {
    return updateObject(state, {
        simsToBeRecharged: updateObject(state.simsToBeRecharged, {
            [action.key]: action.value
        })
    })
}

const setAddRechargePropertiesResponse = (state, action) => {
    return updateObject(state, {
        addRechargeProperties: updateObject(state.addRechargeProperties, {
            [action.key]: action.value
        })
    })
}

const setESimsDetails = (state, action) => {
    return updateObject(state, {
        eSimDetails: updateObject(state.eSimDetails, {
            [action.key]: action.value
        })
    })
}
const distribuzioneDigitale = (state, action) => {
    return updateObject(state, {
        eSimDistribuzione: updateObject(state.eSimDistribuzione, {
            [action.key]: action.value
        })
    })
}

const setAllSelectedAttiveLoading = (state, action) => {
    return updateObject(state, {
        allSelectedAttive: updateObject(state.allSelectedAttive, {
            [action.key]: action.value
        })
    })
}

const simReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_SIM_DATA_SUCCESS:
            return fetchDataSuccessSim(state, action);
        case actionTypes.SIM_SET_SELECTED_TABLE_ROW:
            return setSimSelectedRow(state, action);
        case actionTypes.SIM_SET_SELECTED_TAB:
            return setSimSelectedTab(state, action);
        case actionTypes.SIM_SET_DASHBOARD:
            return setDashboardValue(state, action);
        case actionTypes.SET_SORTING_SIM:
            return setSortingSim(state, action);
        case actionTypes.CHANGE_FILTER_SIM:
            return changeFilterSim(state, action);
        case actionTypes.RESET_FILTER_SIM:
            return resetFilter(state, action);
        case actionTypes.SET_FILTER_CLICKED:
            return setFilterClicked(state, action);
        case actionTypes.SET_LOADING_SIM:
            return setLoadingSim(state, action);
        case actionTypes.SET_WRENCH_LOADING_ATTIVE:
            return setWrenchLoadingSim(state, action);
        case actionTypes.SET_WRENCH_DETAILS_ATTIVE:
            return setWrenchDetailsAttive(state, action);
        case actionTypes.FETCH_SIM_START:
            return fetchSimStart(state, action);
        case actionTypes.FETCH_SIM_ERROR:
            return fetchSimError(state, action);
        case actionTypes.CHANGE_AUTOCOMPLETE_LIST_FOR_SELECTED_SIM:
            return changeAutocompleteListForSim(state, action);
        case actionTypes.CREATE_TAG_SIM:
            return createNewTag(state, action);
        case actionTypes.DELETE_TAG_SIM:
            return deleteTag(state, action);
        case actionTypes.EDIT_TAG_SIM:
            return editTag(state, action);
        case actionTypes.SET_SIM_FILTER_LOADING_OR_ERROR:
            return setFilterLoadingOrError(state, action);
        case actionTypes.SET_SIM_FILTER_INPUT_DATA:
            return setFilterInputData(state, action);
        case actionTypes.UPDATE_CREDIT:
            return updateCredit(state, action);
        case actionTypes.UPDATE_THRESHOLD:
            return updateThreshold(state, action);
        case actionTypes.FETCH_NUMBERS_BLOCKED_LIST:
            return updateNumbersBlockedList(state, action);
        case actionTypes.HANDLE_NUMBER_BLOCKED_LIST_CHANGE:
            return updateNumbersBlockedList(state, action);
        case actionTypes.SET_LOADING_NUMBERS_BLOCKED_LIST:
            return updateLoadingStatusForNumbersBlockedList(state, action);
        case actionTypes.CLEAR_NUMBER_BLOCKED_LIST:
            return clearNumbersBlockedList(state, action);
        case actionTypes.SET_SIM_SUGGESTION_LOADING:
            return setSimSuggestionLoading(state, action);
        case actionTypes.SET_SIM_FILTER_SUGGESTION_DATA:
            return setSimFilterSuggestionData(state, action);
        case actionTypes.UPDATE_CHANGED_TAGS_SIM:
            return updateCheckedTagsSim(state, action);
        case actionTypes.SET_ACTIVE_SERVICE_REQUEST:
            return updateActiveServiceRequest(state, action);
        case actionTypes.SET_WRENCH_DETAILS_IN_ATTIVAZIONE:
            return updateWrenchInAttivazione(state, action);
        case actionTypes.UPDATE_SIM_TAGS_AUTOCOMPLETE_SUCCESS:
            return updateTagFilterAutocomplete(state, action);
        case actionTypes.FETCH_BULK_LIST_ASSOCIATED_TO_SIM:
            return setBulkListAssociatedToSim(state, action);
        case actionTypes.SET_LOADING_BULK_LIST_ASSOCIATED_TO_SIM:
            return setLoadingBulkListAssociatedToSim(state, action);
        case actionTypes.SET_CHANGE_IP_VALUES:
            return updateChangeIpState(state, action);
        case actionTypes.SET_CHANGE_APN_VALUES:
            return updateChangeApnState(state, action);
        case actionTypes.SET_CHANGE_APN_SELECT_DATA:
            return updateChangeApnSelectValues(state, action);
        case actionTypes.GET_COLLABORATORS_SIM:
            return setCollaborators(state, action);
        case actionTypes.SET_LOADING_COLLABORATORS_SIM:
            return setLoadingCollaborators(state, action);
        case actionTypes.SET_ERROR_COLLABORATORS_SIM:
            return setErrorCollaborators(state, action);
        case actionTypes.SET_LOADING_OR_ERROR_SIM_DETAILS:
            return setSimDetailsLoadingOrError(state, action)
        case actionTypes.SET_SIM_DETAILS:
            return setSimDetails(state, action)
        case actionTypes.FETCH_SIM_GROUP_COUNT_SUCCESS:
            return setSimGroupCount(state, action)
        case actionTypes.SET_SIM_GROUP_COUNT_LOADING:
            return setSimGroupCountLoading(state, action)
        case actionTypes.SET_SIM_RESET_PASSWORD_VALUES:
            return setSimResetPasswordValues(state, action)
        case actionTypes.SET_SIM_CSV_DOWNLOAD_LOADING:
            return setSimCsvDownloadLoading(state, action)
        case actionTypes.FETCH_SIMS_TO_BE_RECHARGED:
            return setSimsToBeRecharged(state, action)
        case actionTypes.ADD_RECHARGE_PROPERTIES:
            return setAddRechargePropertiesResponse(state, action)
        case actionTypes.GET_E_SIM_QR_AND_LOADING:
            return setESimsDetails(state, action)
        case actionTypes.DISTRIBUZIONE_DIGITALE:
            return distribuzioneDigitale(state, action)
        case actionTypes.SET_ALL_SELECTED_ATTIVE_LOADNIG:
            return setAllSelectedAttiveLoading(state, action);
        default:
            return state;
    }
};

export default simReducer;
